import { useParams, NavLink, Navigate, useNavigate } from "react-router-dom";
import IdLayout from "../assets/DigitalId/Layout.png";
import fb from "../assets/DigitalId/fb.png";
import mail from "../assets/DigitalId/mail.png";
import internet from "../assets/DigitalId/internet.png";
import { useEffect, useState } from "react";

const DigitalId = () => {
    const navigate = useNavigate();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const { id } = useParams();
    const [member, setMember] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMember = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await fetch(`${API_BASE_URL}/api/members/${id}`);
                if (!response.ok) throw new Error("Network response was not ok");
                const data = await response.json();
                setMember(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchMember();
    }, [id]);

    // 🔴 If error → redirect home
    // useEffect(() => {
    //     if (error) {
    //     navigate("/");
    //     }
    // }, [error, navigate]);

    if (loading) {
    return (
        <div>
            <div
                className="digital-id-bg d-flex justify-content-center align-items-center position-relative"
                style={{
                backgroundColor: "#970273",
                backgroundImage: `url(${IdLayout})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                overflow: "hidden",
                minWidth: 320,
                width: "100vw",
                minHeight: "100vh"
                }}
            ></div>
        </div>
    );
    }
    if (error) return <div>Error: {error}</div>;
    if (!member) return <div>Member not found</div>;


const handleAddContact = () => {
  if (!member) return;

  const vcardUrl = `${API_BASE_URL}/api/members/${member.id}/vcard`;

  // Detect if mobile
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    // On mobile, just open the link so the Contacts app handles it
    window.location.href = vcardUrl;
  } else {
    // On desktop, trigger a download
    const link = document.createElement("a");
    link.href = vcardUrl;
    link.download = `${member.name || "contact"}.vcf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};



    return (
        <div
            className="digital-id-bg d-flex justify-content-center align-items-center position-relative"
            style={{
                backgroundColor: "#970273",
                backgroundImage: `url(${IdLayout})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                overflow: "hidden",
                minWidth: 320,
                width: "100vw",
                minHeight: "100vh"
            }}
        >
            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center">
                <h2 className="text-white mb-5 p-3 rounded-5" style={{backgroundColor: "rgba(255, 255, 255, 0.2)"}}>euodo<span style={{color: "#970073"}}>ó</span> technologies</h2>
                <div className="id-frame rounded-circle mb-5 d-flex shadow-sm" style={{height: "200px", width: "200px", backgroundImage: "linear-gradient(90deg, #231557, #a326a3)", outline: "10px solid #ffffff"}}>
                    <div className="id-photo d-flex justify-content align-items-center m-auto" style={{height: "190px", width: "190px"}}>
                        <img
                            src={require(`../assets/DigitalId/${member.image}`)}
                            alt={member.name}
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            className="rounded-circle p-0"
                        />
                    </div>
                </div>
                
                <div className="id-text text-center text-white mb-5 px-1" style={{maxWidth: "390px"}}>
                    <div className="id-fullname fw-bold fs-2 lh-1 mb-1">{member.name}</div>
                    <div className="id-designation fw-semibold fst-italic">{member.designation}</div>
                    <div className="id-email">{member.email}</div>
                </div>

                <div className="mt-3 d-flex justify-content-center align-items-center gap-3 mb-5">
                    <div className="circle bg-white rounded-circle d-flex justify-content-center align-items-center" style={{height: "50px", width: "50px"}}>
                        <NavLink to="https://www.facebook.com/euodootech/" target="_blank">
                            <img src={fb} alt="Facebook" style={{ width: 40, minWidth: 24 }} />
                        </NavLink>
                    </div>
                    <div className="circle bg-white rounded-circle d-flex justify-content-center align-items-center"  style={{height: "50px", width: "50px"}}>
                        <NavLink to={`mailto:${member.email}`} target="_blank">
                            <img src={mail} alt="Mail" style={{ width: 40, minWidth: 24 }} />
                        </NavLink>
                    </div>
                    <div className="circle bg-white rounded-circle d-flex justify-content-center align-items-center" style={{height: "50px", width: "50px"}}>
                        <NavLink to="/" target="_blank">
                            <img src={internet} alt="Internet" style={{ width: 40, minWidth: 24 }} />
                        </NavLink>
                    </div>
                </div>
                
                <div className="id-cta">
                    <button className="btn bg-white py-2" onClick={handleAddContact} 
                        style={{width: "300px"}}><a href="#" className="text-decoration-none fw-bold" style={{color: "#970073"}}
                    >Let's Talk!</a></button>
                </div>
            </div>
        </div>
    )
}

export default DigitalId